import { useDentalInsuranceReportContext } from '../../..';
import { useInsuranceEligibilityReportContainerContext } from '../../../../providers/insurance-report-container.provider';
import { InsuranceReportTable, useInsuranceReportAccordionContext } from '../../../../shared';
import { useInsuranceTableColumnFilters } from '../../hooks/useInsuranceTableColumnFilters';
import { TableDataType, Vendors } from '../../types/types';
import { InsuranceReportPrintableAccordionSection } from './InsuranceReportPrintableAccordionSection';
import { InsuranceSectionFilterContainer } from './InsuranceSectionFilterContainer';

export const ActiveCoverageTable = () => {
  const { locationId } = useInsuranceEligibilityReportContainerContext();
  const { tablesData, vendor } = useDentalInsuranceReportContext();
  const { isPrintReport } = useInsuranceReportAccordionContext();

  const { tableColumnsList, InsuranceReportTableColumnFilter } = useInsuranceTableColumnFilters({
    tableId: 'activeCoverage',
    isPrintReport,
    locationId,
  });

  if (isPrintReport) {
    return (
      <InsuranceReportPrintableAccordionSection
        tableId='activeCoverage'
        columns={tableColumnsList}
        vendor={vendor as Vendors}
      />
    );
  }

  return (
    <>
      <InsuranceSectionFilterContainer>{InsuranceReportTableColumnFilter}</InsuranceSectionFilterContainer>
      <InsuranceReportTable<TableDataType>
        tableInstanceId={`insurance-report-activeCoverage`}
        columns={tableColumnsList}
        tableData={tablesData.activeCoverage || []}
        isPaginated={!isPrintReport}
      />
    </>
  );
};
